// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EqX0X","heading":"styles_heading__iRQAH","tabs":"styles_tabs__xDbZF"};